
import React from 'react';

export default class ChatIcon extends React.Component {
  render() {
    return (
      <svg className="icon icon-chat" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 209.13 209.23">
        <path d="M178.51 30.67A104.58 104.58 0 0 0 23.69 170.94c-4.69 9.6-10.21 16-16.48 19.06A9.76 9.76 0 0 0 10 208.4a49.81 49.81 0 0 0 7.4.57c12.84 0 26.33-4.42 37.59-12.18A104.62 104.62 0 0 0 178.51 30.67zm-8.37 139.53a92.81 92.81 0 0 1-112.55 14.41A5.88 5.88 0 0 0 51 185a56.43 56.43 0 0 1-32.81 12.05c7-5.26 13-13.41 17.91-24.76a6 6 0 0 0-1-6.31 92.76 92.76 0 1 1 135.07 4.21zm0 0"/>
        <path d="M148.37 70.1H60.75a5.91 5.91 0 1 0 0 11.82h87.62a5.91 5.91 0 0 0 0-11.82zm0 0M148.37 98.7H60.75a5.92 5.92 0 1 0 0 11.83h87.62a5.92 5.92 0 0 0 0-11.83zm0 0M148.37 127.31H60.75a5.92 5.92 0 1 0 0 11.83h87.62a5.92 5.92 0 0 0 0-11.83zm0 0"/>
      </svg>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Icon/ChatIcon.js